import React from "react";
import { Link } from "react-router-dom";
import { MovieItem } from "../../constants/interfaces";
import SearchedMovie from "./SearchedMovie";

interface Props {
  movies: MovieItem[];
  onClickMovie: () => void;
  query: string;
}

const SHOWN_SEARCH_RESULTS = 5;

const SearchResult: React.FC<Props> = (props) => {
  return (
    <div className="searchResult">
      {props.movies.length > 0 ? (
        <>
          {props.movies.slice(0, SHOWN_SEARCH_RESULTS).map((movie) => (
            <SearchedMovie onClick={props.onClickMovie} key={movie.id} movie={movie} />
          ))}
          {props.movies.length > SHOWN_SEARCH_RESULTS && (
            <div className="searchResultSeeMore">
              <Link
                to={`/search?query=${encodeURIComponent(props.query)}`}
                onClick={props.onClickMovie}
                className="block text-center defaultText text-sm"
              >
                See more results
              </Link>
            </div>
          )}
        </>
      ) : (
        <p className="searchResultNotFound">Not found</p>
      )}
    </div>
  );
};

export default SearchResult;
